import { useMemo } from 'react';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const CreativeTargeting = ({ data, divider = ' | ' }) => {
  const { isAllowViewChannel, isAllowProductionType } = useGalleryPermissions();

  const {
    [CREATIVE.CONCEPT]: { [CONCEPT.APPLICATIONS]: conceptApplications },
    [CREATIVE.APPLICATION]: application,
    [CREATIVE.NETWORKS]: networks,
    [CREATIVE.COLOR]: color,
    [CREATIVE.OS]: os,
    [CREATIVE.PRODUCTION_TYPE]: productionType,
    [CREATIVE.ENHANCERS]: enhancers,
    [CREATIVE.CHANNELS]: channels,
    [CREATIVE.LANGUAGE]: language,
  } = data;

  return useMemo(
    () =>
      [
        ...(application ? [application] : conceptApplications),
        ...(networks ? networks : []),
        ...(isAllowViewChannel && channels ? channels : []),
        ...(color ? [color] : []),
        ...(os ? [os] : []),
        ...(isAllowProductionType && productionType
          ? [productionType.name]
          : []),
        ...(enhancers ? enhancers : []),
        ...(language ? [language] : []),
      ].join(divider),
    [data]
  );
};

export default CreativeTargeting;
